import "core-js/stable";
import "regenerator-runtime/runtime";

import "../scripts/pages/initializer";
